export default "__VITE_ASSET__DoEIrNze__"